'use client';
import { jsx } from 'react/jsx-runtime';
import { SwanMenuContextProvider } from './menu.context.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { CollectionContextProvider } from '../../contexts/internal/collection/collection.component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';

function Menu(m) {
    let { children: c, onChange: i, maxHeight: p } = m;
    return useComponentStylesLoaded('Menu', [
        SWAN_STYLE_KEY_MAP.popover,
        SWAN_STYLE_KEY_MAP.listbox
    ]), jsx(CollectionContextProvider, {
        children: jsx(SwanMenuContextProvider, {
            onAction: i,
            maxHeight: p,
            children: c
        })
    });
}

export { Menu };
